import { Box, Grid, Paper } from "@mui/material";
import { nanoid } from "@reduxjs/toolkit";
import React from "react";

const Graph = ({ children }: { children: React.ReactNode[] }) => {
    return (
        <Box
            sx={{
                p: "1rem",
                flexGrow: 1,
                textAlign: "start",
            }}
        >
            <Grid container spacing={2}>
                {children.map((child: any) => (
                    <Grid item xs={12} sm={6} key={nanoid()}>
                        <Paper
                            sx={{
                                p: 2,
                                color: "text.secondary",
                            }}
                        >
                            {child}
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Graph;
